module.exports = __webpack_public_path__ + "img/105026.218165d6.png";